import { Action } from 'redux';
import { CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface ClearDeliverNotBeforeAction extends Action<CheckoutActionTypes.CLEAR_DELIVER_NOT_BEFORE>{
}

export const clearDeliverNotBefore: () => ClearDeliverNotBeforeAction = () => ({
    type: CheckoutActionTypes.CLEAR_DELIVER_NOT_BEFORE
});
clearDeliverNotBefore[ACTION_CREATOR_NAME] = 'clearDeliverNotBefore';

export type ClearDeliverNotBeforeFunc = (...args: Parameters<typeof clearDeliverNotBefore>) => void;